<template>
<div v-loading="loading">
  <pt-page-title :title="`${isEdit ? '编辑' :'新建'}客户`">
    </pt-page-title>
  <pt-add-customer class="pt-add-customer__withData" :isEdit="isEdit" v-model="currentForm" ref="form" @isUpload="isUpload"></pt-add-customer>
  <div class="button-div">
      <el-button type="primary" @click="save" :loading="saveLoading">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
       <el-button type="danger" v-if="isEdit" @click="goDelete(currentForm)">删除</el-button>
  </div>
</div>
</template>

<script>
import PtAddCustomer from './index'
export default {
  name: 'pt-add-customer__withData',
  components: {
    'pt-add-customer': PtAddCustomer
  },
  computed: {
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    },
    tenant () {
      return this.$store.state.saasConfig.tenant
    }
  },
  data () {
    return {
      loading: false,
      saveLoading: false,
      currentForm: {
        base: {
          qualifications: [],
          contracts: [],
          licenses: []
        },
        // 发票
        invoice: {
          type: 'SPECIAL_VAT',
          ableType:[],
        },
      },
      uploading:false
    }
  },
  methods: {
    goDelete (val) {
      this.$confirm('您确定删除该客户吗？', '删除客户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.loading = true
        this.$store.dispatch('deleteVendor', val.id).then(res => {
          this.$message.success('删除客户成功')
          this.$router.push('/customer-manage')
        }).catch(err => {
          this.$message.error(err || '删除客户失败')
        }).finally(()=>{
          this.loading = false
        })
      }).catch(_ => {

      })
    },
    isUpload (val) {
      this.uploading = val
    },
    save () {
      if(this.uploading){
        this.$message.warning('相关文件正在上传，请稍等')
        return
      }
      this.$refs.form.validate().then(formValue => {
        this.loading = true
        const params = this.changeForm()
        this.isEdit ? this.edit(params) : this.create(params)
      })
    },
    changeForm () {
      let copyData = JSON.parse(JSON.stringify(this.currentForm))
      console.log()
      if (copyData.base.licenses && copyData.base.licenses.length) {
        copyData.base.licenses = copyData.base.licenses.map(e => {
          return {
            name: e.name,
            url: e.response || e.url
          }
        })
      }

      copyData.name = copyData.base.name
      copyData.base.address = {
        postAddress: copyData.base.address 
      }
      copyData.type = 'INTERNAL'
      if (!this.isEdit) {
        copyData.roles = ['AGENT']
      }
      return copyData
    },
    create (val) {
      this.$store.dispatch('createOrganization', val).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    edit (val) {
      this.$store.dispatch('updateVendor', val).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    load () {
      this.loading = true
      console.log('this.$route.params', this.$route.params)
      this.$store.dispatch('getVendor', this.$route.params.id).then(data => {
        this.loading = false
        if (!data.base) {
          data.base = {}
        }
        data.base.address = data.base.address.postAddress
        
        if (!data.invoice) {
          data.invoice = {}
        }
        if (!data.invoice.ableType) {
          data.invoice.ableType = []
        }
        this.currentForm = data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
